import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex justify-start items-center" }
const _hoisted_2 = { class: "truncate" }
const _hoisted_3 = { class: "flex justify-start items-center" }
const _hoisted_4 = {
  key: 0,
  class: "mr-s"
}

import { valueInserted } from "@formkit/core";
import { computed, ref } from "vue";
import VueMultiselect from "vue-multiselect";
import ProgressDot from "./ProgressDot.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReactiveSelect',
  props: {
    selectOptions: {},
    trackBy: {},
    optionLabel: {},
    customLabel: {},
    allowEmpty: { type: Boolean },
    reset: {},
    placeholder: {},
    afterList: {},
    onAfterList: {},
    value: {},
    onChange: {},
    loading: { type: Boolean },
    disabled: { type: Boolean },
    searchable: { type: Boolean }
  },
  setup(__props: any) {

const multiselect = ref<VueMultiselect>();

const props = __props;

const selectModel = computed({
  get() {
    return props.value;
  },
  set(option) {
    props.onChange(option);
  },
});
function reset() {
  selectModel.value = [];
  multiselect.value?.deactivate();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueMultiselect), {
    options: props.selectOptions,
    "track-by": props.trackBy,
    label: props.optionLabel,
    "allow-empty": props.allowEmpty ?? true,
    class: "w-full rounded border-2 border-darken bg-white",
    loading: props.loading ?? false,
    disabled: props.disabled ?? false,
    "custom-label": props.customLabel,
    "max-height": 150,
    modelValue: selectModel.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectModel).value = $event)),
    showNoOptions: false,
    "options-limit": 100,
    placeholder: props.placeholder,
    ref_key: "multiselect",
    ref: multiselect,
    searchable: props.searchable
  }, _createSlots({
    beforeList: _withCtx(() => [
      (props.reset)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (reset())),
            class: "multiselect__option"
          }, _toDisplayString(props.reset), 1))
        : _createCommentVNode("", true)
    ]),
    afterList: _withCtx(() => [
      (props.afterList && props.onAfterList)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (props.onAfterList())),
            class: "multiselect__option"
          }, _toDisplayString(props.afterList), 1))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (props.optionLabel)
      ? {
          name: "singleLabel",
          fn: _withCtx((prop) => [
            _createElementVNode("div", _hoisted_1, [
              (prop.option.progress !== undefined)
                ? (_openBlock(), _createBlock(ProgressDot, {
                    key: 0,
                    progress: prop.option.progress,
                    class: "mr-xs"
                  }, null, 8, ["progress"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_2, _toDisplayString(`${prop.option[props.optionLabel]}`.split("----")[0]), 1)
            ])
          ]),
          key: "0"
        }
      : undefined,
    (props.optionLabel)
      ? {
          name: "option",
          fn: _withCtx((prop) => [
            _createElementVNode("div", _hoisted_3, [
              (prop.option.progress !== undefined)
                ? (_openBlock(), _createBlock(ProgressDot, {
                    key: 0,
                    progress: prop.option.progress,
                    class: "mr-s"
                  }, null, 8, ["progress"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(`${prop.option[props.optionLabel]}`.split("----")[0]), 1)
            ]),
            (prop.option.desc !== undefined)
              ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(prop.option.desc), 1))
              : _createCommentVNode("", true)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["options", "track-by", "label", "allow-empty", "loading", "disabled", "custom-label", "modelValue", "placeholder", "searchable"]))
}
}

})